<template>
    <div class="app" id="order">
        <div class="title">
            <div class="title-left">
                <span>{{title1}}</span>
            </div>
            <div class="title-right">
                <span>{{title2}}</span>
                <span>{{title3}}</span>
            </div>
        </div>
        <div :style="{height: tag == 'A' ? 'calc(100% - 72px)' : 'calc(100% - 40px)'}">
            <el-table :key="symbolKey" :show-summary="tag == 'A'" :summary-method="getSummaries" v-loading="tableLoading" ref="multipleTable" :data="tableData" :border="tag == 'A'? true : false" :stripe="tag == 'A'" style="width: 100%;" :row-key="getTableRowKey" height="100%" max-height="100%" :span-method="arraySpanMethod" :highlight-current-row="tag == 'A'" @row-dblclick="handleTableDBClick" @row-click="tableExpandChange" lazy :load="subListLoad" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :cell-class-name="cellClassName" @sort-change="sortChange">
                <el-table-column type="index" :index="indexMethod" width="48" align="center" v-if="tag == 'A'"></el-table-column>
                <el-table-column width="48" v-if="tag != 'A'"></el-table-column>
                <el-table-column label="客户" min-width="150px" label-class-name="sort-box" prop="customerName">
                    <template #header>
                        <el-popover placement="left" trigger="click" ref="popover_customerID" @show="popoverShow('customerID')">
                            <div class="query_btn_group">
                                <select-multiple :select-data="queryInfo.customerID" isClear isScroll isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
                                <el-button type="text" @click.stop="tableFilter('customerID')">筛选</el-button>
                            </div>
                            <div slot="reference" :class="['reference', queryInfo.customerID.isFilter ? 'highlight' : '' ]"><label>客户</label><i style="margin: 0 10px 0 5px" class='el-icon-arrow-down'></i></div>
                        </el-popover>
                        <span class="caret-wrapper" v-if="tag == 'A'"><i class="sort-caret ascending" :class="isAscend ? 'blue1' : ''" @click="sortClick('customerName', 'ascending')"></i><i class="sort-caret descending" :class="isDescend ? 'blue2' :''" @click="sortClick('customerName', 'descending')"></i></span>
                    </template>
                    <template slot-scope="scope">
                        <div class="customer-box" v-if="scope.row.hasChildren">
                            <div style="color: #000; font-weight: bold;">{{scope.row.customerName}}<span style="color: #E6A23C; margin-left: 16px;">(截止今日合计：{{scope.row.balanceAmt}}，{{dateStr}}合计：{{scope.row.totalAmt}}) </span></div>
                            <!-- <div>
                                <el-button size="mini" type="primary">收欠款</el-button>
                                <el-button style="margin-left: 10px;" size="mini" type="success">调整</el-button>
                            </div> -->
                        </div>
                        <div v-else>{{scope.row.customerName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="结算单位" min-width="150px" prop="settlementCustomerName" v-if="$store.state.power.isSettlementCustomer == 'Y'">
                    <template #header>
                        <el-popover placement="left" trigger="click" ref="popover_settlementCustomerId" @show="popoverShow('settlementCustomerId')">
                            <div class="query_btn_group">
                                <select-multiple :select-data="queryInfo.settlementCustomerId" isClear isScroll isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
                                <el-button type="text" @click.stop="tableFilter('settlementCustomerId')">筛选</el-button>
                            </div>
                            <div slot="reference" :class="['reference', queryInfo.settlementCustomerId.isFilter ? 'highlight' : '' ]">
                                <label>结算单位</label><i style="margin: 0 10px 0 5px" class='el-icon-arrow-down'></i>
                            </div>
                        </el-popover>
                        <!-- <span class="caret-wrapper" v-if="tag == 'A'">
                            <i class="sort-caret ascending" :class="isAscend ? 'blue1' : ''" @click="sortClick('settlementCustomerName', 'ascending')"></i>
                            <i class="sort-caret descending" :class="isDescend ? 'blue2' :''" @click="sortClick('settlementCustomerName', 'descending')"></i>
                        </span> -->
                    </template>
                    <template slot-scope="scope">
                        <div class="customer-box" v-if="scope.row.hasChildren">
                            <div style="color: #000; font-weight: bold;">{{scope.row.settlementCustomerName}}</div>
                        </div>
                        <div v-else>{{scope.row.settlementCustomerName}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="helpCode" width="100" label="助记码"></el-table-column>
                <el-table-column prop="financialBrandName" label="品牌" :sortable="tag == 'A' ? 'custom' : false"></el-table-column>
                <el-table-column prop="prePayAmt" v-if="tag == 'A'" label="截止今日预收款" width="130" sortable="custom"></el-table-column>
                <el-table-column prop="arrearAmt" v-if="tag == 'A'" label="截止今日应收款" width="130" sortable="custom"></el-table-column>
                <el-table-column prop="balanceAmt" v-if="tag == 'A'" label="截止今日余额" width="130" sortable="custom"></el-table-column>
                <el-table-column label="业务员" v-if="tag != 'A'" prop="salesManName">
                    <template #header>
                        <el-popover placement="bottom" trigger="click" ref="popover_salesmanID" @show="popoverShow('salesmanID')">
                            <div class="query_btn_group">
                                <select-multiple :select-data="queryInfo.salesmanID" isClear isScroll></select-multiple>
                                <el-button type="text" @click="tableFilter('salesmanID')">筛选</el-button>
                            </div>
                            <div slot="reference" :class="['reference', queryInfo.salesmanID.isFilter ? 'highlight' : '' ]"><label>业务员</label><i class='el-icon-arrow-down'></i></div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" v-if="tag != 'A'" prop="entryUserName"></el-table-column>
                <el-table-column label="金额" v-if="tag != 'A'" prop="billAmt"></el-table-column>
                <el-table-column label="已结算" v-if="tag == 'B'" prop="checkAmt"></el-table-column>
                <el-table-column label="待结算" v-if="tag == 'B'" prop="unCheckAmt"></el-table-column>
                <el-table-column label="日期" v-if="tag != 'A'" prop="entryDate"></el-table-column>
                <el-table-column label="备注" v-if="tag != 'A'" prop="remark" width="150px"></el-table-column>
                <el-table-column label="操作" v-if="tag == 'B'" width="100px">
                    <template slot-scope="{ row }">
                        <template v-if="row.billType != 'SKD'">
                            <el-button 
                                size="mini" 
                                :type="row.unCheckAmt == 0 ? 'primary' : ''"
                                @click="row.unCheckAmt == 0 ? viewCollectArrears(row) : view(row)">
                                {{row.unCheckAmt == 0 ? '查看' : '收欠款'}}
                            </el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination v-if="tag == 'A'" class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageParams.page" :page-sizes="[10, 20, 100]" :page-size="pageParams.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
import { toFixedRe, debounce } from '@/assets/js/common.js'
export default {
    props: {
        tag: String,
        args: Object
    },
    mixins: [selectMultipleTableColumnListCommonMixins],
    data() {
        return {
            tableLoading: false,
            tableData: [],
            symbolKey: '',
            queryInfo: {
                settlementCustomerId: { submitName: 'settlementCustomerId', selected: [],
                    isFilter: false,
                    isMultiple: true,
                    isAll: false,
                    isShowAll: false,
                    isFilterable: true,
                    isRemote: true,
                    isPagination: true,
                    isReSearch: false,
                    valueIsObj: true,
                    list: [],
                    placeholder: '请选择结算单位', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' }
                },
                customerID: {
                    submitName: 'customerID',
                    selected: [],
                    isFilter: false,
                    isMultiple: true,
                    isAll: false,
                    isShowAll: false,
                    isFilterable: true,
                    isRemote: true,
                    isPagination: true,
                    isReSearch: false,
                    valueIsObj: true,
                    list: [],
                    placeholder: '请选择客户',
                    request: {
                        url: '/Account/customerDefine/getCustomerListForVue.html',
                        type: 'post',
                        params: {
                            page: 1,
                            size: 10,
                            isFitterEnabled: 'N',
                            customerType: 'S'
                        },
                        text: '',
                        value: ''
                    }
                },
                salesmanID: {
                    submitName: 'salesmanID',
                    isFilter: false,
                    selected: '',
                    isMultiple: true,
                    isAll: false,
                    isShowAll: false,
                    isFilterable: true,
                    isRemote: true,
                    isPagination: true,
                    isReSearch: false,
                    valueIsObj: true,
                    list: [],
                    placeholder: '请选择业务员',
                    request: {
                        url: '/Account/userDefine/selectUserListForVue.html',
                        type: 'post',
                        params: { page: 1, size: 10 },
                        text: '',
                        value: ''
                    }
                },
            },
            params: this.args,
            dateStr: this.args.beginDate + '至' + this.args.endDate,
            title1: '',
            title2: '',
            title3: '',
            pageParams: {
                page: 1,
                size: 20
            },
            total: 0,
            isAscend: false,
            isDescend: false,
            summaries: {}
        }
    },
    computed: {},
    watch: {
        args(val) {
            for (let j in this.queryInfo) {
                if (Array.isArray(this.queryInfo[j].selected)) {
                    this.params[j] = this.queryInfo[j].selected.map(element => ("'" + element.value + "'")).join(',')
                } else {
                    this.params[j] = this.queryInfo[j].selected.value
                }
            }
            this.params = { ...this.params, ...val }
        },
    },
    created() {
        // this.getTableData()
    },
    methods: {
        async getTableData() {
            // console.log(this.params.customerID, this.queryInfo.customerID.selected)
            this.tableLoading = true
            let url = '/Account/SalPayBalanceVue/selectPayBalanceForVue.html'
            if (this.tag == 'B') {
                url = '/Account/SalPayBalanceVue/selectArrearList.html'
            } else if (this.tag == 'C') {
                url = '/Account/SalPayBalanceVue/selectPrePayCustomerList.html'
            }
            let obj = { ...this.params }
            if (this.tag == 'A') {
                obj = { ...obj, ...this.pageParams }
            } else {
                delete obj.sortField
                delete obj.softBy
            }
            try {
                if (this.params.beginDate && this.params.endDate) {
                    this.dateStr = this.params.beginDate + '至' + this.params.endDate
                }
                const { data: res } = await this.$http.post(url, this.Qs.stringify(obj))
                this.tableLoading = false
                if (this.tag != 'A') {
                    for (let k in this.queryInfo) {
                        if (Array.isArray(this.queryInfo[k].selected)) {
                            const tempMap = new Map()
                            let list = [...this.queryInfo[k].list, ...this.queryInfo[k].selected].filter(item => !tempMap.has(item.value) && tempMap.set(item.value, 1)) // 解决滚动加载时，回显造成的key值重复的问题
                            // console.log(this.queryInfo[k].list)
                            this.$set(this.queryInfo[k], 'list', list)
                            this.queryInfo[k].request.params.page = 1
                        }
                    }
                }
                if (res.code != 'success') return this.$message.error(res.message)
                let { data, total, sum = '' } = JSON.parse(res.result)
                if (this.tag == 'A' && sum) {
                    this.summaries = JSON.parse(sum)
                }
                console.log(this.summaries)
                this.total = total ? total : 0
                if (data) {
                    let { title1, title2, title3, list} = JSON.parse(data)
                    this.title1= title1
                    this.title2= title2
                    this.title3= title3
                    this.tableData = list
                    if (this.tag != 'A') {
                        this.tableData.map((item, index) => {
                            item.index = index
                            item.hasChildren = true
                            this.$refs['multipleTable'].toggleRowExpansion(item, false)
                            // let {tree, treeNode, resolve} = this.parentMap.get(item.customerID)
                            // console.log(tree)
                            return item
                        })
                        this.$nextTick(() => {
                            this.symbolKey = Symbol(new Date().toString())
                        })
                    }
                }
            } catch (e) {
                this.tableLoading = false
            }
        },
        getSummaries(param) {
            const { columns } = param
            const sums = [];
            for (let key in this.summaries) {
                columns.forEach((column, index) => {
                    if (index == 1) {
                        sums[index] = '合计'
                        return
                    }
                    if (column.property == key) {
                        sums[index] = this.summaries[key]
                        return
                    } else {
                        sums[index] = ''
                        return
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs['multipleTable'].doLayout();
            })
            return sums
        },
        getTableRowKey(row) {
            if (!row.hasChildren && this.tag != 'A') {
                return row.detailID
            }
            if (this.tag == 'A') {
                return row.customerID + row.financialBrandID
            }
            return row.customerID
        },
        cellClassName({ row, column, rowIndex, columnIndex }) {
            if (column.property == 'checkAmt' && this.tag == 'B') {
                return 'red'
            }
            if (column.property == 'entryUserName' && this.tag == 'C') {
                return 'red'
            }
        },
        /**
         * 表格合并
         * @param {*} param0
         * row 表格每一行的数据
         * column 表格每一列的数据
         * rowIndex 表格的行索引,不包括表头,从0开始
         * columnIndex 表格的列索引,从0开始
         */
        arraySpanMethod({ row, columnIndex }) {
            if (this.tag != 'A' && row.hasChildren) {
                let _num = this.tag == 'B' ? 12 : 9
                if (columnIndex == 1) { // 假设客户列和结算单位列的索引分别为1和2
                    return [1, _num]; // 新增一行且保持原有功能
                } else if (columnIndex.toString().match(/2|3|4|5|6|7|8|9|10|11|12|13|14/i)) {
                    return [0, 0];
                }
            }
        },
        expandSelection(selection, row) {

        },
        handleTableDBClick(row) {
            if (this.tag == 'A') return false
            if (row.hasChildren) return false
            // 订货单直接用新的详情页面打开
            if(row.billType == 'DHD'){
                console.log('open vue3: billNo: ', row.soureBillNo)
                let width = window.top.document.browser.availiframeWidth.value
                let height = window.top.document.browser.availiframeHeight.value
                top.addPanel('订货录单详情', `/yunsierp3/index.html#/enterPage/bookEntry?billType=DHD&billNo=${ row.soureBillNo }`, width, height, true)
                return
            }
            this.$emit('billDetailOpen', row);
        },
        expandTableDBClick({ billNo }) {
            // this.$root.getDetailList(billNo)
        },
        expandTableEnter(row) {
            // this.$set(row, 'isShowBtn', true)
        },
        expandTableLeave(row) {
            // if (row['isDisableLeave']) return
            // this.$set(row, 'isShowBtn', false)
        },
        tableExpandChange(row, index) {
            if (!row.hasChildren) return false
            let parent = document.getElementById('pane-' + this.tag)
            let els = parent.getElementsByClassName('el-table__expand-icon')
            if (els.length > 0) {
                // console.log(parent.getElementsByClassName('el-table__expand-icon'))
                els[row.index].classList.add("dafult")
                if (parent.getElementsByClassName('el-table__expand-icon--expanded')) {
                    // this.$refs[this.tabsActive][0].toggleRowExpansion(row, false)
                    els[row.index].classList.remove("dafult")
                    els[row.index].click()
                }
            }
        },
        async subListLoad(tree, treeNode, resolve) {
            if (!tree.hasChildren) return false
            // console.log(tree)
            let obj = { ...this.params }
            obj.customerID = tree.customerID
            let url = '/Account/SalPayBalanceVue/selectArrearDetailList.html'
            if (this.tag == 'C') {
                url = '/Account/SalPayBalanceVue/selectPrePayDetailList.html'
            }
            const { data: res } = await this.$http.post(url, this.Qs.stringify(obj))
            if (res.code != 'success') return this.$message.error(res.message)
            let { data } = JSON.parse(res.result)
            resolve(JSON.parse(data))
        },
        // 筛选框打开时触发事件
        popoverShow(tag) {
            const popover = this.$refs['popover_' + tag]
            popover.$nextTick(() => {
                popover.$children[0].focus()
            })
        },
        // 自定义筛选
        tableFilter(tag) {
            this.$refs['popover_' + tag].doClose()
            let item = this.queryInfo[tag]
            if (Array.isArray(item.selected)) {
                this.params[tag] = item.selected.map(element => ("'" + element.value + "'")).join(',')
                item.isFilter = item.selected.length ? true : false
            } else {
                this.params[tag] = item.selected.value
                item.isFilter = item.selected.value ? true : false
            }
            // console.log(this.params)
            this.getTableData()
        },
        handleSizeChange(newSize) {
            this.pageParams.size = newSize
            this.getTableData()
        },
        handleCurrentChange(newPage) {
            this.pageParams.page = newPage
            this.getTableData()
        },
        sortClick(prop, order) {
            if (this.isPopoverShow) return false
            if (this.tag != 'A') return false
            this.$refs['multipleTable'].clearSort()
            let softBy = ''
            console.log(order)
            if (order == 'ascending') {
                this.isAscend = !this.isAscend
                this.isDescend = false
                softBy = this.isAscend ? 'ASC' : ''
            } else if (order == 'descending') {
                this.isDescend = !this.isDescend
                this.isAscend = false 
                softBy = this.isDescend ? 'DESC' : ''
            }
            this.params['sortField'] = softBy ? prop : ''
            this.params['softBy'] = softBy
            this.pageParams.page = 1
            this.getTableData()
        },
        sortChange({ prop, order }) {
            if (this.tag != 'A') return false
            this.isAscend = false
            this.isDescend = false
            let softBy = ''
            console.log(order)
            if (order == 'ascending') {
                softBy = 'ASC'
            } else if (order == 'descending') {
                softBy = 'DESC'
            }
            this.params['sortField'] = softBy ? prop : ''
            this.params['softBy'] = softBy
            this.pageParams.page = 1
            this.getTableData()
        },
        indexMethod(index) {
            return ((this.pageParams.page - 1) * this.pageParams.size) + (index + 1)
        },
        view(row) {
            console.log(row);
            let width = top.document.browser.availiframeWidth.value;
            let height = top.document.browser.availiframeHeight.value;
            
            if(this.$store.state.power.isSettlementCustomer == 'Y') {
                // 获取是否开启先对账再收款流程
                const isReconciliation = this.$store.state.power.isReconciliation;
                
                if (isReconciliation == 'Y') {
                    // 如果开启了先对账再收款流程
                    if (row.isReconciliation == 'Y') {
                        // 已对账，直接跳转到收款页面
                        const params = {
                            settlementCustomerId: row.settlementCustomerId,
                            settlementCustomerName: row.settlementCustomerName,
                            billNo: row.soureBillNo
                        };
                        const url = `/yunsierp3/index.html#/payment/collectArrears?${this.Qs.stringify(params)}`;
                        top.addPanel('门店收欠款', url, width, height, true);
                    } else {
                        // 未对账，提示用户
                        this.$message.warning('您需要先对账再收款，请先在客户欠款对账中完成对账');
                    }
                } else {
                    // 未开启先对账再收款流程，直接跳转到收款页面
                    const params = {
                        settlementCustomerId: row.settlementCustomerId,
                        settlementCustomerName: row.settlementCustomerName,
                        billNo: row.soureBillNo
                    };
                    const url = `/yunsierp3/index.html#/payment/collectArrears?${this.Qs.stringify(params)}`;
                    top.addPanel('门店收欠款', url, width, height, true);
                }
            } else {
                // 原有逻辑
                let { customerID, customerName, financialBrandID, financialBrandName } = row;
                let url = '/templates/vue-account/dist/index.htm#/customerArrearPerOrder?' + this.Qs.stringify({ customerID, customerName, financialBrandID, financialBrandName });
                top.addPanel('收欠款', url, width, height, true);
            }
        },
        viewCollectArrears(row) {
            let width = top.document.browser.availiframeWidth.value;
            let height = top.document.browser.availiframeHeight.value;
            
            const params = {
                soureBillNo: row.soureBillNo
            };
            const url = `/yunsierp3/index.html#/payment/collectArrearsView?${this.Qs.stringify(params)}`;
            top.addPanel('门店收欠款查看', url, width, height, true);
        }
    }
}
</script>
<style scoped lang="less">
.app {
    height: 100%;

    .title {
        height: 40px;
        display: flex;
        font-size: 14px;
        color: #F56C6C;
        font-weight: bolder;
        .title-left {
            display: flex;
            align-items: center;
        }
        .title-right {
            display: flex;
            flex-flow: column;
            margin-left: 16px;
        }
    }

    /deep/.el-table {
        font-size: 12px;

        td,
        th {
            padding: 6px 0;

        }

        .sort-box {
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .blue1 {
            border-bottom-color: #409EFF !important;
        }

        .blue2 {
            border-top-color: #409EFF  !important;
        }

        .el-table__body {
            tr {
                cursor: pointer;
            }
        }

        .el-table__expanded-cell {
            padding: 0;
        }

        .reference {
            cursor: pointer;
        }

        .reference.highlight label {
            color: #409EFF;
        }

        .table-column-merge {
            text-align: center;
        }

        .red {
            .cell {
                color: #F56C6C !important;
            }
        }
    }

    .vehicleName-row {
        color: #303133;
        font-weight: bold;
    }

    .customer-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}

.query_btn_group {
    display: flex;
}

.query_btn_group .el-button {
    margin-left: 6px;
    color: #606266;
}

.query_btn_group .el-button:hover {
    color: #409EFF;
}

#order {
    /deep/.el-table {
        .red {
            .cell {
                color: #F56C6C !important;
            }
        }
    }
}
</style>